import { InjectionToken, NgModule } from '@angular/core';
import { LIB_CONFIG } from '@challenger/care/lib-config';
import { environment } from '../environments/environment';
import { IEnvironmentContent } from '../environments/environment.interface';

export type AppConfig = IEnvironmentContent;
export const APP_CONFIG = new InjectionToken<AppConfig>('app.config');
export const APP_CONFIG_VALUE: any = {
  ...environment,
};

@NgModule({
  providers: [
    {
      provide: APP_CONFIG,
      useValue: APP_CONFIG_VALUE,
    },
    {
      provide: LIB_CONFIG,
      useValue: APP_CONFIG_VALUE,
    },
  ],
})
export class AppConfigModule {}
